import { createFileRoute } from '@tanstack/react-router';

import { SupplierConversationPage } from '@/features/messages/supplier-messages';

export const Route = createFileRoute('/_app/supplier/$orgId/messages/$conversationId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { orgId, conversationId } = Route.useParams();
  return (
    <SupplierConversationPage key={conversationId} orgId={orgId} conversationId={conversationId} />
  );
}
